<template>
    <div
        class="relative min-h-[34.884vw] overflow-hidden rounded-lg border border-grey-300 xs:min-h-[150px]"
        @click="handleClick(item)"
    >
        <img
            v-if="item?.label === 'hot'"
            class="absolute left-0 top-0 h-auto w-10"
            :src="`${staticUrl}/assets/icons/hot.png`"
            alt="hot icon"
        />
        <img
            v-if="item?.label === 'new'"
            class="absolute left-0 top-0 h-auto w-10"
            :src="`${staticUrl}/assets/icons/new.png`"
            alt="new icon"
        />
        <img
            :src="`/assets/icons/casino/provider/${gameType}/bg.png`"
            class="absolute left-1/2 top-1/4 -translate-x-1/2 -translate-y-1/2 scale-75"
            alt="background"
            onerror="this.style.display='none'"
        />
        <img
            class="absolute right-0 z-10 h-full rounded-lg object-contain"
            :src="item.image"
            :alt="item.name"
        />
        <div class="absolute inset-[2px] flex items-end rounded-lg">
            <!-- <img
                class="absolute left-[-3px] h-[100%] min-w-[338px] rounded-lg object-contain"
                src="/assets/icons/casino/provider/frame.png"
                :alt="item.name"
            /> -->
            <div class="absolute bottom-[18px] left-[10px] z-20 xs:left-[25px]">
                <img
                    v-if="item.icon"
                    class="h-[56px] w-[56px]"
                    :src="item.icon"
                    :alt="item.name"
                />
                <p
                    class="max-w-[130px] text-center text-[4.651vw] font-semibold uppercase xs:max-w-[150px] xs:text-xl"
                >
                    {{ item.name ? item.name : item.nameMb }}
                </p>
            </div>
        </div>
    </div>
</template>

<script setup>
import {
    useGamesStore,
    useAlertStore,
    useUserStore,
    useModalStore,
} from '~/stores'

defineProps(['item', 'gameType'])
const emit = defineEmits(['partner-selected'])
const alertStore = useAlertStore()
const gameStoreInstance = useGamesStore()
const { getGameUrl } = gameStoreInstance
const router = useRouter()
const staticUrl = useRuntimeConfig().public.staticUrl
const { isMobile } = useDevice()
const useUserStoreInstance = useUserStore()
const useModalStoreInstance = useModalStore()
const handleGetGameUrl = async (toSend) => {
    if (!useUserStoreInstance.isLoggedIn) {
        useModalStoreInstance.showLoginModal = true
        return
    }
    if (isMobile) {
        const newtab = window.open('', '_blank')
        try {
            const { data } = await getGameUrl(toSend)
            if (data?.value?.status === 'OK') {
                const { url } = data.value.data
                if (newtab) newtab.location.href = url
            } else if (data?.value?.data?.url === '') {
                if (newtab) newtab.close()
                // NO URL recieved
                alertStore.showMessageError({
                    value: {
                        statusCode: 'SHOW_MESSAGE',
                        message: t('error.server_is_busy'),
                    },
                })
            } else if (data.value === null) {
                // no auth
                if (newtab) newtab.close()
            }
        } catch (error) {
            if (newtab) newtab.close()
            alertStore.showMessageError(error)
        }
    } else {
        const { data } = await getGameUrl(toSend)
        if (data?.value?.status === 'OK') {
            const { url } = data.value.data
            navigateTo(url, {
                open: {
                    target: '_blank',
                },
            })
        }
    }
}

const handleClick = async (item) => {
    if (item.key === 'digmaan') {
        const toSend = {
            partnerProvider: 'cockfight',
            partnerGameId: 'lobby',
        }
        await handleGetGameUrl(toSend)
        return
    }
    let link = item.link
    if (item.link.includes('casino')) {
        link = '/' + link
        emit('partner-selected', item.key)
        return
    }
    if (item.link.includes('games')) {
        emit('partner-selected', item.key)
        return
    }
    // this line might not be reached, but for back compatibility left
    await router.push(link)
}
</script>
